import React from "react";

import { useSelector } from 'react-redux'

import ZoomOutMapOutlinedIcon from '@mui/icons-material/ZoomOutMapOutlined';

import { getNodeAvatar } from "../../../utils";

export const TitleTableCell = ({
  node,
  classes,
  nodeId,
  tableId,
  allOntNodes,
  openTrplFormFull,
  titleForViewOnly,
}) => {

  const highlighted = useSelector(
    state => state.tableUI.tableId === tableId
      && nodeId
      && state.tableUI.highlightedNodeId === nodeId
  );

  return (
    <div
      style={{
        width: '100%',
        textOverflow: 'ellipsis',
        position: 'relative',
        pointerEvents: titleForViewOnly ? 'none' : '',
      }}
      className={`${classes.alignCenter} ${classes.fillAvailable} ${titleForViewOnly ? '' : classes.pointer} `}
      onClick={() =>
        openTrplFormFull({
          node,
          mode: 'edit',
        })
      }
    >
      <div className={`${allOntNodes ? classes.ml10 : classes.ml5} ${classes.alignCenter}`} style={{ overflow: 'hidden' }}>
        {node && node.pic ? (
          <img alt="node-avatar" src={getNodeAvatar(node, '24')} className={classes.tableCellLeftNodeImg} />
        ) : null}
        <span
          className={`table-cell-left-node-link ${classes.tableCellLeftNodeLink}`}
          style={{ fontWeight: titleForViewOnly ? 500 : '' }}
        >
          {node ? node.title : 'No title'}
        </span>
      </div>
      {highlighted && !titleForViewOnly ?
        <div
          className={`${classes.spaceAround}`}
        >
          <ZoomOutMapOutlinedIcon
            style={{
              paddingLeft: '5px',
              // position: 'absolute',
              fontSize: '16px',
              // right: '0px',
              // top: '1px',
            }}/>
        </div>
      : null}
    </div>
  )
};
